import TextButton from 'components/Luxkit/Button/TextButton'
import LineHeartIcon from 'components/Luxkit/Icons/line/LineHeartIcon'
import Group from 'components/utils/Group'
import React, { useCallback } from 'react'
import { TripItem } from 'tripPlanner/types/tripItem'
import * as Analytics from 'analytics/analytics'
import { AnalyticsPage } from 'contexts/Analytics/analyticsPageContext'
import useAddSuggestedItem from 'tripPlanner/hooks/concierge/useAddSuggestedItem'
import { offerIdOrPlaceId } from 'tripPlanner/utils/analytics'
import { addTripIdParam } from 'tripPlanner/utils/url'
import useCanEditTrip from 'tripPlanner/hooks/useCanEditTrip'

interface Props {
  item: TripItem
  offerLink?: string
}

function SuggestionCTAs({ item, offerLink }: Props) {
  const { tripId } = item
  const canEdit = useCanEditTrip()
  const onSave = useAddSuggestedItem(item)

  const onView = useCallback(() => {
    const analyticsId = offerIdOrPlaceId(item)
    if (analyticsId) {
      Analytics.trackClientEvent({
        subject: `view_recommended_item_${analyticsId}`,
        action: 'concierge',
        type: 'interaction',
        category: AnalyticsPage.tripPlanner,
      })
    }
  }, [item])

  return (
    <Group
      direction="horizontal"
      verticalAlign="center"
      horizontalAlign="stretch"
      tabletHorizontalAlign="space-between"
      gap={12}
    >
      <TextButton
        kind="tertiary"
        onClick={onSave}
        size="medium"
        startIcon={<LineHeartIcon colour="favourite" />}
      >
        Save to trip
      </TextButton>
      {offerLink && <TextButton
        kind="primary"
        to={addTripIdParam(offerLink, tripId, canEdit)}
        target="_blank"
        onClick={onView}
        size="medium"
      >
        View
      </TextButton>}
    </Group>
  )
}

export default SuggestionCTAs
